export interface Offer {
  title: string;
  img: string;
  href: string;
  description: string;
}

export const OFFERS: readonly Offer[] = [
  {
    title: 'Refer a Friend',
    img: '/graphics/referfriend.png',
    href: '/account/refer',
    description: 'Share your referral code and earn amazing rewards.'
  },
  {
    title: 'Shop & Earn',
    img: '/graphics/madinaplus.png',
    href: '/account/wallet',
    description: 'Earn points anytime you complete your shopping on Madina.'
  }
];
